import { render } from "./MaterialSheetInventory.vue?vue&type=template&id=60a2abd0"
import script from "./MaterialSheetInventory.vue?vue&type=script&lang=js"
export * from "./MaterialSheetInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__